import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';


const CreatecampaignModals = ({ setShowCreate, setShowImportvideo }) => {

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  console.log(subdomain_name);

  return (
    <>
      {/* <!-- Modal --> */}
      <div
        className="modal fade show d-block"
        id="modalcreatevideo"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalcreatevideoTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="font18">
                Videos{" "}
                <i>
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/question.png"}
                    className="img-fluid"
                    alt="img"
                  />
                </i>
              </h4>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setShowCreate(false);
                }}
              >
                <i
                  className="fas fa-times"
                  style={{ fontSize: "20px", color: "#cacccf" }}
                ></i>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="videos">
                <div className="video_rw p-4">
                  <div className="row">

                      <div className="col-md-6 col-6 p-4">
                        <Link
                          to="/create-campaign"
                          className="cv_col d-inline-block pb-2 text-center text-decoration-none"
                        >
                          <figure className="mb-2 d-inline-block position-relative">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/video_icon_6.png"
                              }
                              alt="img"
                            />
                          </figure>
                          <h6 className="m-0 ">Video from Templates</h6>
                        </Link>
                      </div>
                      
                    
                    {
                      (subdomain_name !== 'vidwise') && (subdomain_name !== 'nicheflick') && (
                    <div className="col-md-6 col-6 p-4">
                      <button
                        className="cv_col d-inline-block pb-2 text-center text-decoration-none border-0 bg-transparent"
                        onClick={() => setShowImportvideo(true)}
                      >
                        <figure className="mb-2 d-inline-block position-relative">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/video_icon_1.png"
                            }
                            alt="Import video Icon"
                          />
                        </figure>
                        <h6 className="m-0">Import Video</h6>
                      </button>
                    </div>
                      )
                    }


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatecampaignModals;
